module.exports = __webpack_public_path__ + "img/华西医院.b856f672.png";